import {
    Options,
    Vue
} from "vue-class-component";


@Options({ template: `<slot></slot>` })
export default class DashboardCaseStatisticsListHandler extends Vue { }